import React from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EndpointDescEditProps {
  onSubmit: () => void;
  endpointNode: string;
  endpointDesc: string;
}
export const EndpointDescEdit = ({
  onSubmit,
  endpointNode,
  endpointDesc,
}: EndpointDescEditProps) => {
  const api = useApi();
  const [desc, setDesc] = React.useState(endpointDesc || '');

  const epNamePost = useMutation(api.setEndpointDescriptionApiV1SetEndpointDescriptionPost, {
    onSuccess() {
      toast.success('Updated Endpoint description successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    epNamePost.mutate({
      ep_id: endpointNode,
      description: desc,
    });
  };

  return (
    <Box pt={2}>
      <TextField
        fullWidth
        id="endpoint-desc"
        label="Endpoint Description"
        variant="outlined"
        sx={{ mb: 4 }}
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
        multiline
        minRows={4}
      />

      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit}>
          Save Description
        </Button>
      </Box>
    </Box>
  );
};
